<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">FOREWARD—EN SAGA</h2>
<p class="calibre11">At least once in every generation there turns up a person who is
embarrassing to the Custodians of History. With neither talent nor
ambition, nor studious application nor admirable character, this person
succeeds where the bright and the studious and the intellectually
honest would have failed miserably. Stubborn, egocentric, vain—often
stupid—our person blunders in where the wise and the sincere would
not dare. His hide is thicker than that of the rhinoceros. He is not
abashed to tell the surgeon where to ply his scalpel, or to instruct
the statesman on a course of diplomacy. His little knowledge is a
dangerous thing—for other people.</p>
<p class="calibre11">His success is due to the law of averages.</p>
<p class="calibre11">History holds many accounts where the brave and the brilliant have
stepped in at the right time to avoid disaster. Yet there are more
bums than geniuses, more cowards than heroes and more laziness than
ambition in our human race, so it is not surprising that there should
be occasions when a bum or a self-centered braggart should find that
history has a special niche waiting for him.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0f693178